/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_C1Inputs */

const en_guide_json_rest_api_c1 = /** @type {(inputs: Guide_Json_Rest_Api_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content-Type, Accept, and request bodies`)
};

const ko_guide_json_rest_api_c1 = /** @type {(inputs: Guide_Json_Rest_Api_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content-Type과 Accept, 그리고 요청 본문`)
};

const ja_guide_json_rest_api_c1 = /** @type {(inputs: Guide_Json_Rest_Api_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content-Type、Accept、リクエストボディ`)
};

/**
* | output |
* | --- |
* | "Content-Type, Accept, and request bodies" |
*
* @param {Guide_Json_Rest_Api_C1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_c1 = /** @type {((inputs?: Guide_Json_Rest_Api_C1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_C1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_c1(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_c1(inputs)
	return ja_guide_json_rest_api_c1(inputs)
});